module.exports = __webpack_public_path__ + "static/img/student-icon.c09d3ed9.svg";